import { Card, Grid, Stack, Text, useMantineTheme } from "@mantine/core";

type Props = {
	recruitPositionCount: number;
	maxRecruitPositionCount: number;
	aiSelectionCount: number;
	maxAiSelectionCount: number;
};

export function RecruitPositionStatistics({
	recruitPositionCount,
	maxRecruitPositionCount,
	aiSelectionCount,
	maxAiSelectionCount,
}: Props) {
	const theme = useMantineTheme();

	return (
		<Card withBorder p={24} radius="md">
			<Grid align="center">
				<Grid.Col span={6}>
					<Stack gap={4}>
						<Text size="sm" fw={600} c={theme.colors.gray[6]}>
							選考基準数
						</Text>
						<Text fz={24} fw={700}>
							<span style={{ fontSize: 40 }}>{recruitPositionCount}</span>
							<span style={{ fontSize: 32 }}>/{maxRecruitPositionCount}</span>件
						</Text>
						<Text size="sm" c={theme.colors.gray[6]}>
							Lite版では、{maxRecruitPositionCount}件まで生成が可能です
						</Text>
					</Stack>
				</Grid.Col>
				<Grid.Col span={6}>
					<Stack gap={4}>
						<Text size="sm" fw={600} c={theme.colors.gray[6]}>
							AI書類選考回数
						</Text>
						<Text fz={24} fw={700}>
							<span style={{ fontSize: 40 }}>{aiSelectionCount}</span>
							<span style={{ fontSize: 32 }}>/{maxAiSelectionCount}</span>回
						</Text>
						<Text size="sm" c={theme.colors.gray[6]}>
							Lite版では、最大{maxAiSelectionCount}回まで選考が可能です
						</Text>
					</Stack>
				</Grid.Col>
			</Grid>
		</Card>
	);
}
